import { useDispatch } from 'react-redux'
import { updateContact, createContact } from '@store/ducks/simulate'
import { getCookie } from '@client/services/cookies'

export default function useFunnelStage(country) {
  const dispatch = useDispatch()

  async function setFunnelStage(data) {
    const base = {
      department: 'Human Resources',
      token: getCookie('hubspotutk'),
      country,
    }

    if (data.id) {
      await dispatch(updateContact(data))
    } else {
      await dispatch(createContact({ ...base, ...data }))
    }
  }

  return {
    setFunnelStage,
  }
}
